import { useModals } from "ModalProvider";
import Button from "components/base/Button";
import { FileSelector } from "components/base/Form";
import Page from "components/base/Page";
import { Alert } from "components/base/Toast";
import Excel from "exceljs";
import moment from "moment";
import ErrorsView from "./ErrorsView";
import FSIOrders from "./FSIOrders";
import ImportOdooOrdersForFSIView from "./ImportOdooOrdersForFSIView";
import NewOrdersForm from "./NewOrdersForm";

const addressFields = [
  { field: "name", maxLength: 35 },
  { field: "contact", maxLength: 35 },
  { field: "address1", maxLength: 35 },
  { field: "address2", maxLength: 35 },
  { field: "city", maxLength: 30 },
  { field: "state", maxLength: 30 },
  { field: "postalCode", maxLength: 20 },
  { field: "phone", maxLength: 20 },
  { field: "email", maxLength: 100 },
];

const FsiPage = () => {
  const odooModal = useModals();
  const { present, hide } = useModals();

  const xlsxReader = new FileReader();
  const wb = new Excel.Workbook();

  xlsxReader.onload = function (e) {
    wb.xlsx
      .load(e.target.result)
      .then(handleQbXlsx)
      .catch((error) => {
        Alert("error", `Fail to read xlsx file. Error: ${error}`);
      });
  };

  function extractOrders(wb) {
    let orders = {};
    let errors = [];

    const ws = wb.getWorksheet("Sheet1");

    for (var i = 2; i <= ws.rowCount; i++) {
      const row = ws.getRow(i);

      const item = {
        itemNumber: row.getCell("N").value,
        quantity: row.getCell("O").value,
      };

      const orderNumber = row.getCell("A").value;

      if (orderNumber)
        if (orders[orderNumber]) {
          orders[orderNumber].lineItems.push(item);
        } else {
          const address = {
            name: row.getCell("E").text,
            contact: row.getCell("F").text,
            address1: row.getCell("G").text,
            address2: row.getCell("H").text,
            city: row.getCell("I").text,
            state: row.getCell("J").text,
            postalCode: row.getCell("K").text,
            countryCode: "US",
            phone: row.getCell("L").text,
            email: row.getCell("M").text,
          };

          addressFields.forEach(({ field, maxLength }) => {
            if (address[field].length > maxLength) {
              errors.push(
                `Order ${orderNumber} - ${field.charAt(0).toUpperCase() + field.slice(1)} is too long: ${
                  address[field]
                }. Max length is ${maxLength} characters.`,
              );
            }
          });

          orders[orderNumber] = {
            orderNumber,
            alternateOrderNumber: row.getCell("S").text,
            orderDate: moment(row.getCell("B").value).format("YYYY-MM-DD"),
            shippingCode: row.getCell("D").text,
            shippingAddress: address,
            billingAddress: address,
            lineItems: [item],
            tradingPartner: "WHOLE",
            orderMessage: row.getCell("P").text,
          };
        }
    }
    return { orders, errors };
  }

  function handleQbXlsx(wb) {
    const { orders, errors } = extractOrders(wb);
    if (errors.length > 0) {
      present({
        title: "Errors",
        children: <ErrorsView errors={errors} />,
      });
    } else {
      present({
        title: "Create Orders",
        hideChildren: true,
        children: (
          <NewOrdersForm initialOrders={Object.values(orders)} hide={hide} />
        ),
      });
    }
  }

  function showOdooOrders() {
    odooModal.present({
      title: "Import Odoo Orders to FSI",
      children: <ImportOdooOrdersForFSIView />,
      fullscreen: true,
    });
  }

  return (
    <Page staticHeader title="FSI" className="h-screen">
      <div className="flex flex-col overflow-auto">
        <div className="p-6">
          <div className="flex items-center space-x-4">
            <Button onClick={showOdooOrders}>Import from Odoo</Button>
            <FileSelector
              bold
              title="Import QB XLSX"
              accept=".xlsx"
              onChange={async (e) => {
                const file = e.target.files[0];
                xlsxReader.readAsArrayBuffer(file);
                e.target.value = null;
              }}
            />
          </div>

          <div className="mt-1 opacity-70">
            When you import from QB, make sure the file you upload contains a
            sheet named as <b>Sheet1</b> and the columns are "Num Date | Ship
            Date | Via |Name | Name Contact | Ship To Address 1 | Ship To
            Address 2 | Ship To City | Ship To State | Ship Zip | Name Phone # |
            Name E-Mail | Item | Qty | Other 1 | Shipping # | Order Class | P.
            O. #".{" "}
            <a
              className="underline"
              href="https://cdn.waboba.com/public/QB+10252021+-+2.xlsx"
            >
              Download example file
            </a>
            .
          </div>
        </div>

        <FSIOrders />
      </div>
    </Page>
  );
};

export default FsiPage;
